import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {getVipList, WechatVipPay, VipPay} from '@/api/miscellaneous';
import {Toast} from 'vant';
import {useRoute} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenMembership',
  setup(__props, { expose }) {
  expose();

const {query} = useRoute();
var active = ref(3);
const list = ref<any[]>([]);
const radio = ref('00');
const price = ref(0);
const payData = ref({
    vipId: 3,
    month: 12,
    rebate: 1,
    vipfrom: query.vipfrom || 'other',
    fromid: '',
    other: 'app',
});
if (query.viprank != undefined && query.viprank != '') {
    active.value = Number(query.viprank);
}

const tabChange = (name: number) => {
    console.log(1111);
    let data;
    if (name == 7) {
        radio.value = '10';
        data = list.value[2].list[0];
    } else if (name == 6) {
        radio.value = '10';
        data = list.value[1].list[0];
    } else if (name == 3) {
        radio.value = '00';
        data = list.value[0].list[0];
    }
    const {rebate, duration_month, rate, points_6} = data;
    payData.value.vipId = rebate;
    payData.value.month = duration_month;
    payData.value.rebate = rate;
    switch (name) {
        case 3:
            //const {rebate: rabate3, duration_month: duration_month3, rate: rate3, points_3} = data;
            price.value = data.points_3;
            payData.value.vipId = data.rebate;
            payData.value.month = data.duration_month;
            payData.value.rebate = data.rate;
            console.log(payData, price, '---payData3');
            break;
        case 6:
            //const {rebate: rabate6, duration_month: duration_month6, rate: rate6, points_6} = data;
            price.value = data.points_6;
            payData.value.vipId = data.rebate;
            payData.value.month = data.duration_month;
            payData.value.rebate = data.rate;
            console.log(payData, price, '---payData6');
            break;
        case 7:
            //const {rebate: rebate7, duration_month: duration_month7, rate: rate7, points_7} = data;
            price.value = data.points_7;
            payData.value.vipId = data.rebate;
            payData.value.month = data.duration_month;
            payData.value.rebate = data.rate;
            console.log(payData, price, '---payData7');
            break;
    }
};

const changeCard = (data: any) => {
    console.log(data, '------------data');
    const {rebate, duration_month, rate, points_6} = data;
    payData.value.vipId = rebate;
    payData.value.month = duration_month;
    payData.value.rebate = rate;
    price.value = points_6;
};

const getList = () => {
    getVipList().then((res: any) => {
        const allList: any[] = res[0].info,
            silverList = allList.filter(el => el.rebate == 3),
            goldList = allList.filter(el => el.rebate == 6),
            crownList = allList.filter(el => el.rebate == 7);
        console.log(silverList, goldList, crownList);
        switch (active.value) {
            case 3:
                //const {rebate: rabate3, duration_month: duration_month3, rate: rate3, points_3} = silverList[0];
                price.value = silverList[0].points_3;
                payData.value.vipId = active.value;
                payData.value.month = silverList[0].duration_month;
                payData.value.rebate = silverList[0].rate;
                console.log(payData, price, '---payData3');
                break;
            case 6:
                //const {rebate: rabate6, duration_month: duration_month6, rate: rate6, points_6} = goldList[0];
                price.value = goldList[0].points_6;
                payData.value.vipId = active.value;
                payData.value.month = goldList[0].duration_month;
                payData.value.rebate = goldList[0].rate;
                console.log(payData, price, '---payData6');
                break;
            case 7:
                //const {rebate: rebate7, duration_month: duration_month7, rate: rate7, points_7} = crownList[0];
                price.value = crownList[0].points_7;
                payData.value.vipId = active.value;
                payData.value.month = crownList[0].duration_month;
                payData.value.rebate = crownList[0].rate;
                console.log(payData, price, '---payData7');
                break;
        }
        console.log(payData, price, '-----------data---------');
        list.value = [
            {
                name: 'silver',
                list: silverList,
                equity: res[0].silverParams,
                value: 3,
                card: require('../assets/img/pay/silver_vip_card.png'),
            },
            {
                name: 'gold',
                list: goldList,
                equity: res[0].goldParams,
                value: 6,
                card: require('../assets/img/pay/gold_vip_card.jpg'),
            },
            {
                name: 'crown',
                list: crownList,
                equity: res[0].crownParams,
                value: 7,
                card: require('../assets/img/pay/crown_vip_card.jpg'),
            },
        ];
    });
};
getList();

const pay = () => {
    console.log(payData.value, 'submitdata');
    WechatVipPay(payData.value).then((res: any) => {
        let {id} = res;
        console.log(res, '--res1');
        VipPay({id}).then((res: any) => {
            console.log(res, '--res2');
            let resData = JSON.parse(res);
            const {appid: appId, noncestr: nonceStr, sign: paySign, signType, timestamp: timeStamp} = resData;
            const data = {
                appId, //公众号名称，由商户传入
                timeStamp: String(timeStamp), //时间戳，自1970年以来的秒数
                nonceStr, //随机串
                package: resData.package, //扩展包
                signType, //微信签名方式：
                paySign, //微信签名
            };
            WeixinJSBridge.invoke('getBrandWCPayRequest', data, function (res: any) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    Toast.success('支付成功');
                } else {
                    Toast.fail(res.errMsg || '支付失败,请联系管理员');
                }
            });
        });
    });
};

const __returned__ = { query, active, list, radio, price, payData, tabChange, changeCard, getList, pay, ref, getVipList, WechatVipPay, VipPay, Toast, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})